module.exports = __webpack_public_path__ + "535bcf7dd3feb41ec20507c3c5b81efb.woff";